import {
    optionTitle_inlineTranslation,
    optionSearchTerms_translation,
} from './InlineTranslationOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const InlineTranslationOption: LazyOption = createLazyOption(
    {
        key: 'inlineTranslation',
        titleStringKey: optionTitle_inlineTranslation,
        searchTermsStringKey: optionSearchTerms_translation,
        isHidden: () => {
            return !isFeatureEnabled('rp-inlineTranslation');
        },
    },
    lazyFullModule,
    m => m.default
);
export default InlineTranslationOption;
